export default {"src":"/_next/static/media/chevrons-right.5ec50796.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};